var map = {
	"./costume_1.webp": 2533,
	"./costume_2.webp": 6161,
	"./costume_3.webp": 7293,
	"./costume_4.webp": 6691,
	"./costume_5.webp": 4889,
	"./costume_6.webp": 3142,
	"./costume_7.webp": 2190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2052;